import InputField from '@/modules/document/_component/fields/InputField.vue';
import List from '@/modules/document/_component/fields/options/List.vue';
import SelectField from '@/modules/document/_component/fields/SelectField.vue';
import CheckboxField from '@/modules/document/_component/fields/CheckboxField.vue';
import RadioField from '@/modules/document/_component/fields/RadioField.vue';
import MarkdownField from '@/modules/document/_component/fields/MarkdownField.vue';
import Table from '@/modules/document/_component/fields/options/Table.vue';
import TableField from '@/modules/document/_component/fields/TableField.vue';
import BooleanField from '@/modules/document/_component/fields/BooleanField.vue';
import BooleanValue from '@/modules/document/_component/values/BooleanValue.vue';
import TableValue from '@/modules/document/_component/values/TableValue.vue';
import FileField from '@/modules/document/_component/fields/FileField.vue';
import FileValue from '@/modules/document/_component/values/FileValue.vue';
import MarkdownValue from '@/modules/document/_component/values/MarkdownValue.vue';

const types = [
    {
        text: 'Text',
        value: 'text',
        component: InputField,
    },
    {
        text: 'Number',
        value: 'number',
        component: InputField,
    },
    {
        text: 'Date',
        value: 'date',
        component: InputField,
    },
    {
        text: 'Select',
        value: 'select',
        component: SelectField,
        optionsComponent: List,
    },
    {
        text: 'Boolean',
        value: 'boolean',
        component: BooleanField,
        valueComponent: BooleanValue,
    },
    {
        text: 'Checkbox list',
        value: 'checkbox',
        component: CheckboxField,
        optionsComponent: List,
    },
    {
        text: 'Radio list',
        value: 'radio',
        component: RadioField,
        optionsComponent: List,
    },
    {
        text: 'File',
        value: 'file',
        component: FileField,
        valueComponent: FileValue,
    },
    {
        text: 'Image',
        value: 'image',
        component: FileField,
        valueComponent: FileValue,
    },
    {
        text: 'Table',
        value: 'table',
        optionsComponent: Table,
        component: TableField,
        valueComponent: TableValue,

    },
    {
        text: 'Rich text',
        value: 'markdown',
        component: MarkdownField,
        valueComponent: MarkdownValue,
    },
];

export default types;
